import { render, staticRenderFns } from "./EdenCustomPeriod.vue?vue&type=template&id=2f639524"
import script from "./EdenCustomPeriod.vue?vue&type=script&lang=js"
export * from "./EdenCustomPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports